import "./PredefinedRoutePreview.css";
import edit from "../../assets/icons/edit.svg";
import remove from "../../assets/icons/remove.svg";
import { useNavigate } from "react-router-dom";

const PredefinedRoutePreview = ({ route, setDeleteRoute, categories = [] }) => {
  const navigate = useNavigate();

  const handleEditRoute = () => {
    navigate(`/predefined-routes/edit/${route.id}`);
  };

  const matchedCategory = categories.find(
    (category) => category.nameEnglish === route.category,
  );

  return (
    <div className="routePreviewContainer">
      <div className="routePreviewMain">
        <h3>{route.titleLat || route.titleEng || route.titleCir}</h3>
        <p>{route.location || "-"}</p>
      </div>

      <div className="routePreviewMeta">
        <p>
          <strong>Kategorija:</strong>{" "}
          {matchedCategory?.nameLatin || route.category || "-"}
        </p>

        <p>
          <strong>Prioritet:</strong> {route.priority ?? "-"}
        </p>

        <p>
          <strong>Trajanje:</strong> {route.duration || "-"}
        </p>

        <p>
          <strong>Stanice na putu:</strong> {route.waypoints?.length || 0}
        </p>
      </div>

      <div className="btnsContainer">
        <img
          onClick={handleEditRoute}
          className="btn-edit"
          src={edit}
          alt="edit button"
        />
        <img
          className="btn-remove"
          src={remove}
          alt="remove button"
          onClick={() => setDeleteRoute(route)}
        />
      </div>
    </div>
  );
};

export default PredefinedRoutePreview;
